import { useState, useCallback } from 'react';

const REQUIRED_ELEMENT_TYPES = ['singleChoice', 'gridChoice', 'horizontalSingleChoice', 'emailInput'];

export function useValidation() {
    const [isCurrentScreenValid, setIsCurrentScreenValid] = useState(true);

    const isValidEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const hasRequiredFields = (screen) => {
        return screen.elements.some(element =>
            REQUIRED_ELEMENT_TYPES.includes(element.type) && element.required
        );
    };

    const validateRequiredFields = (screen, formData) => {
        return screen.elements.every(element => {
            if (!element.required) return true;
            if (!REQUIRED_ELEMENT_TYPES.includes(element.type)) return true;

            if (element.type === 'emailInput') {
                const email = formData.get('email');
                return email && isValidEmail(email);
            }

            return formData.has(element.name);
        });
    };

    const showValidationError = (screen, formData) => {
        const hasEmailInput = screen.elements.some(el =>
            el.type === 'emailInput' && el.required
        );

        if (hasEmailInput) {
            const email = formData.get('email');
            if (!email) {
                alert('Please enter your email address.');
            } else if (!isValidEmail(email)) {
                alert('Please enter a valid email address.');
            }
        } else {
            alert('Please make a selection before continuing.');
        }
    };

    const setScreenValidation = useCallback((isValid) => {
        setIsCurrentScreenValid(isValid);
    }, []);

    return {
        isCurrentScreenValid,
        isValidEmail,
        hasRequiredFields,
        validateRequiredFields,
        showValidationError,
        setScreenValidation,
    };
}
